import { UUID } from '@/api/generatedApi';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQuery } from '@tanstack/react-query';

export const GET_PART_FINDER_REPORT_IMAGE_QUERY_KEY = 'partFinderReports.getImage';

export const useGetPartFinderReportImage = ({
  reportId,
  index,
  version,
  enabled = true,
}: {
  reportId: UUID;
  index: number;
  version?: string;
  enabled?: boolean;
}) => {
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();
  const {
    data: image,
    isLoading,
    error,
  } = useQuery({
    queryKey: [GET_PART_FINDER_REPORT_IMAGE_QUERY_KEY, { reportId, index, version }],
    queryFn: async () => {
      const { data, status, headers } = await api.http.request<Blob>({
        path: `/tenants/${tenantId}/part-finder/reports/${reportId}/images/${index}.png`,
        method: 'GET',
        secure: true,
        format: 'blob',
        query: version ? { v: version } : undefined,
      });

      if (status !== 200) {
        throw new Error('Failed to download part finder report image');
      }

      const contentType = headers['content-type'];
      return URL.createObjectURL(new Blob([data], { type: typeof contentType === 'string' ? contentType : undefined }));
    },
    enabled: enabled && !!reportId && !!tenantId,
    refetchOnMount: false,
    retry: false,
    staleTime: 60 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
  });

  return { image, isLoading, error };
};
